module.exports = __webpack_public_path__ + "media/images/web/landings/students/s10-68d60d1392cb005ddaa8fe222824e785.jpg";